var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.384,
    height: 20,
    viewBox: "0 0 15.384 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-unlock",
    "data-name": "Icon ionic-ios-unlock",
    d: "M20.211,10.3H11.173V7.99a3.269,3.269,0,0,1,6.538,0h0a.673.673,0,0,0,1.346,0h0a4.616,4.616,0,1,0-9.231.062V10.3H8.673A1.929,1.929,0,0,0,6.75,12.221v9.231a1.929,1.929,0,0,0,1.923,1.923H20.211a1.929,1.929,0,0,0,1.923-1.923V12.221A1.929,1.929,0,0,0,20.211,10.3Zm-5.1,6v3.308a.689.689,0,0,1-.639.692.674.674,0,0,1-.707-.673V16.3a1.538,1.538,0,1,1,1.346,0Z",
    transform: "translate(-6.75 -3.374)",
    fill: "#797979"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.08551be73f54bcb1c4d76d7e947bfb66.svg";
export { ForwardRef as ReactComponent };